import { useAtom } from '@reatom/npm-react'
import * as DateF from 'date-fns'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { CurrencyModel } from '@root/entities/currency'
import { DATE_FORMAT } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

import type { AggregatedPositionModel } from '@root/entities/position'

type TradPositionProfitInfoProps = {
  position: AggregatedPositionModel
}

export const TradPositionProfitInfo: React.FC<TradPositionProfitInfoProps> = ({
  position,
}) => {
  const [pnlNative] = useAtom(position.pnlNative)
  const [pnlUsd] = useAtom(position.pnlUsd)
  const [createdAt] = useAtom(position.createdAt)
  const { t } = useTranslation()

  return (
    <Root>
      <Title>{t('common.profit')}</Title>
      <ProfitContainer>
        <ProfitNative>
          <Numeric
            value={pnlNative.pnlNative}
            preset="currency-amount-short"
            currency={CurrencyModel.nativeOf(position.network).ticker}
          />
        </ProfitNative>
        <ProfitUsd>
          <Numeric
            value={pnlUsd.pnlUsd}
            preset="currency-amount-short"
            currency="$"
          />
        </ProfitUsd>
      </ProfitContainer>
      <DateText>
        {DateF.format(createdAt, DATE_FORMAT.dd_MM_yy__HH_mm)}
      </DateText>
    </Root>
  )
}

const Root = styled.div`
  z-index: 1;
`

const Title = styled.div`
  color: var(--text-12);
  text-align: center;

  text-transform: uppercase;

  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`

const ProfitNative = styled.div`
  color: var(--pnl-color);
`
const ProfitUsd = styled.div`
  color: var(--pnl-color);
  font-weight: 400;
`

const ProfitContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  justify-content: center;

  margin-bottom: 6px;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`

const DateText = styled.div`
  color: var(--textA-7);
  text-align: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
`
